export const proteinRegionColorMap = {
	ORF1ab: "rgba(255, 99, 132, 0.5)",
	S: "rgba(54, 102, 205, 0.5)",
	ORF3a: "rgba(255, 206, 86, 0.5)",
	E: "rgba(75, 192, 192, 0.5)",
	M: "rgba(153, 102, 255, 0.5)",
	ORF6: "rgba(255, 159, 64, 0.5)",
	ORF7a: "rgba(155, 23, 112, 0.5)",
	ORF7b: "rgba(240, 65, 102, 0.5)",
	ORF8: "rgba(54, 162, 235, 0.5)",
	N: "rgba(55, 26, 86, 0.5)",
	ORF10: "rgba(75, 102, 142, 0.5)",
};
const alpha = 0.25;
export const proteinRegionColorMapAnnotations = {
	ORF1ab: `rgba(255, 99, 132, ${alpha})`,
	S: `rgba(54, 102, 205, ${alpha})`,
	ORF3a: `rgba(255, 206, 86, ${alpha})`,
	E: `rgba(75, 192, 192, ${alpha})`,
	M: `rgba(153, 102, 255, ${alpha})`,
	ORF6: `rgba(255, 159, 64, ${alpha})`,
	ORF7a: `rgba(155, 23, 112, ${alpha})`,
	ORF7b: `rgba(240, 65, 102, ${alpha})`,
	ORF8: `rgba(54, 162, 235, ${alpha})`,
	N: `rgba(55, 26, 86, ${alpha})`,
	ORF10: `rgba(75, 102, 142, ${alpha})`,
};
